'use client';

import { useMemo } from 'react';
import { CdnImg } from '@/features/cdn-img';
import { AnalyseKey, useConfigsAnalyseAttribute } from '@/features/next-analyse';
import { usePopupBanners } from '@/features/popup-banner/hooks/use-popup-banners';

interface PopupBannerListProps {
	closePopupBanner: () => void;
	isfromLoginBanner?: boolean;
}

export const PopupBannerList = ({
	closePopupBanner,
	isfromLoginBanner
}: PopupBannerListProps) => {
	const banners = usePopupBanners({ isfromLoginBanner });
	const refinedAnalyseKey = banners.find(banner => banner.refinedAnalyseKey)?.refinedAnalyseKey;
	const analyseConfigs = useMemo(
		() => (refinedAnalyseKey ? [{ key: refinedAnalyseKey, analyseKey: AnalyseKey.Refined }] : []),
		[refinedAnalyseKey],
	);
	const analyseRef = useConfigsAnalyseAttribute(analyseConfigs);

	const handleNavigate = (navigate: () => void) => () => {
		navigate();
		closePopupBanner();
	};

	return (
		<div className="popup-banner-list">
			{banners.map(banner => (
				<div
					key={banner.name}
					className="popup-banner-list__item"
					onClick={handleNavigate(banner.navigate)}
					ref={banner.refinedAnalyseKey ? analyseRef : undefined}
				>
					<CdnImg
						src={banner.href}
						alt={banner.name}
						width={640}
						height={200}
						onError={(e) => {
							const target = e.currentTarget;
							if (target.dataset.fallbackApplied || !banner.fallbackHref) return;
							target.dataset.fallbackApplied = 'true';
							target.src = banner.fallbackHref;
						}}
						isGalaxyFolder={true}
					/>
				</div>
			))}
		</div>
	);
};
